import { render, staticRenderFns } from "./relatorioFinanceiroSuspensaoJudicial.vue?vue&type=template&id=02d4c954"
import script from "./relatorioFinanceiroSuspensaoJudicial.vue?vue&type=script&lang=js"
export * from "./relatorioFinanceiroSuspensaoJudicial.vue?vue&type=script&lang=js"
import style0 from "./relatorioFinanceiroSuspensaoJudicial.vue?vue&type=style&index=0&id=02d4c954&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports